import { IRestaurantFullInfoState } from './restaurantFullInfoContext';
import { RestaurantFullInfoActionTypes, TRestaurantFullInfoAction } from './restaurantFullInfoActions';

export const restaurantFullInfoReducer = (
	state: IRestaurantFullInfoState,
	action: TRestaurantFullInfoAction,
): IRestaurantFullInfoState => {
	switch (action.type) {
		case RestaurantFullInfoActionTypes.CHANGE_RESTAURANT_FULL_INFO_VISIBLE_FORM:
			return {
				...state,
				restaurantFullInfoVisibleForm: action.payload.restaurantFullInfoVisibleForm,
			};
		case RestaurantFullInfoActionTypes.SET_RESTAURANT_FOR_FULL_INFO:
			return {
				...state,
				restaurantForFullInfo: action.payload.restaurantForFullInfo,
			};
		case RestaurantFullInfoActionTypes.SET_LOCALIZATION_GROUP:
			return {
				...state,
				selectedLocalizationGroup: action.payload.selectedLocalizationGroup,
			};
		case RestaurantFullInfoActionTypes.SET_LOCALIZATION_LANGUAGE:
			return {
				...state,
				selectedLocalizationLanguage: action.payload.selectedLocalizationLanguage,
			};
		case RestaurantFullInfoActionTypes.SET_LOCALIZATION_DATA:
			return {
				...state,
				localizationData: action.payload.localizationData,
			};
		case RestaurantFullInfoActionTypes.SET_STYLE_DATA:
			return {
				...state,
				styleData: action.payload.styleData,
			};
		case RestaurantFullInfoActionTypes.SET_STYLE_GROUP:
			return {
				...state,
				selectedStyleGroup: action.payload.selectedStyleGroup,
			};
		case RestaurantFullInfoActionTypes.SET_STYLE_LANGUAGE:
			return {
				...state,
				selectedStyleLanguage: action.payload.selectedStyleLanguage,
			};
		case RestaurantFullInfoActionTypes.SET_LATEST_SOFTWARE_UPDATE_DATA:
			return {
				...state,
				latestSoftwareUpdateData: action.payload.latestSoftwareUpdateData,
			};
		case RestaurantFullInfoActionTypes.SET_REPORT:
			return {
				...state,
				report: action.payload.report,
			};
		case RestaurantFullInfoActionTypes.SET_ANDROID_WATCHES:
			return {
				...state,
				androidWatches: action.payload.androidWatches,
			};
		default:
			return state;
	}
};
